import {useFetch} from "../useFetch";
import {Tbo} from "../../types/api/guide/tbo.types";
import {tboService} from "../../services/guide/tbo-service";


export const useFetchAllTbo = () => {
    const { isLoading, error, data, refetch } = useFetch<Tbo[]>(tboService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
